import { Component, Input, OnInit } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';
import { WhatsNewService } from '../../views/whatsnew/services/whatsnew.service';
import {IWhatsNew} from '../../views/whatsnew/interfaces/IWhatsNew';
import {versionInfo} from '../../version-info';
import {Page} from '../../model/page';
import {Subscription} from 'rxjs/Subscription';
import {Title} from '@angular/platform-browser';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-whats-new',
  templateUrl: './app-whats-new.component.html',
  styleUrls: ['./app-whats-new.component.scss'],
})

export class AppWhatsNewComponent implements OnInit {
  @Input() displayWhatsNew: boolean;
  versionInfo = versionInfo;

  private subscription: Subscription;

  public page = new Page();
  rows = new Array<IWhatsNew>();
  cols = [];
  totalRecords = 0;
  size = 50;

  constructor(private sidebarService: SidebarService,
              private whatsNewService: WhatsNewService,
              private toastr: ToastrService,
              private title: Title
  ) {
    this.page.pageNumber = 0;
    this.page.size = 50;
    this.title.setTitle('What\'s New');
  }

  ngOnInit() {
    this.getData();
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  getData() {
    this.subscription = this.whatsNewService.getDataList(this.page).subscribe(result => {
      this.rows = result.data;
    }, error => {
      this.toastr.error('TimeOut occured', 'Service Error', {
        timeOut: 3000,
      });
    });
  }
  onHide() {
    this.sidebarService.toggleWhatsNew();
  }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/components/app-whats-new/app-whats-new.component.ts